/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusSquareIcon32Regular = forwardRef('PlusSquareIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M17 10a1 1 0 1 0-2 0v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 3A5.5 5.5 0 0 0 3 8.5v15A5.5 5.5 0 0 0 8.5 29h15a5.5 5.5 0 0 0 5.5-5.5v-15A5.5 5.5 0 0 0 23.5 3h-15ZM5 8.5A3.5 3.5 0 0 1 8.5 5h15A3.5 3.5 0 0 1 27 8.5v15a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 23.5v-15Z" })));
});
